const initBlock = async function( block ) {
	const $categorySelectWrap = block.find( "[data-faq-select-wrap]" );
	const $categorySelect = block.find( "[data-faq-category-select]" );
	let currentPage = 2;
	let selectedCategory = $categorySelect.val();
	let ajax = null;
	const $faqMain = block.find( "[data-faq-main-content]" );
	const $faqMessage = block.find( "[data-faq-message]" );
	const $faqPreloader = block.find( "[data-faq-preloader]" );
	const $faqWrapper = block.find( "[data-faq-wrapper]" );
	const $faqList = block.find( "[data-faq-list]" );
	const $faqItems = block.find( "[data-faq-items]" );
	const $readMoreButton = block.find( "[data-faq-load-more]" );
	const $readMoreButtonTextElem = $readMoreButton.find( ".button-text" );
	const readMoreButtonDefaultText = $readMoreButtonTextElem?.text() ? $readMoreButtonTextElem.text() : "";
	const $postsPerPage = $readMoreButton.data( "posts-per-page" );
	const $image = block.find( "[data-faq-image]" );
	const $imageParent = $image.parent();

	// eslint-disable-next-line no-unused-vars
	const { select2 } = await import( "select2" );
	await import( "select2/dist/css/select2.min.css" );

	function loadMoreQuestions() {
		if ( ajax ) {return;}
		ajax = $.ajax( {
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_questions",
				page: currentPage,
				category: selectedCategory,
				postsPerPage: $postsPerPage
			},
			beforeSend: function() {
				return new Promise( ( resolve ) => {
					if ( currentPage === 1 ) {
						$image.animate( {
							opacity: 0,
						} );
						$faqWrapper.animate( {
							opacity: 0,
						} );
						$faqPreloader.fadeIn( () => {
							resolve();
						} );
					} else {
						$readMoreButtonTextElem?.text( "Loading..." );
					}

					$categorySelect.prop( "disabled", true );
				} );
			},
			/* eslint-disable complexity */
			success: async function( response ) {
				if ( response ) {
					$readMoreButtonTextElem?.text( readMoreButtonDefaultText );
					response.show_read_more_button
						? $readMoreButton.fadeIn()
						: $readMoreButton.fadeOut();

					$faqList.css( "height", `${$faqItems.outerHeight()}px` );
					currentPage === 1 ?	$faqItems.html( response.html ) : $faqItems.append( response.html );

					requestAnimationFrame( () => {
						$faqList.animate( {
							height: $faqItems[0].scrollHeight,
						}, function() {
							$faqList.css( "height", "" );
						} );
					} );

					if ( response.image ) {
						await handleImage( response.image );
					}
				} else {
					$readMoreButton.fadeOut();
				}

				if ( currentPage === 1 ) {
					$image.animate( {
						opacity: 1,
					} );
					$faqWrapper.animate( {
						opacity: 1,
					} );
					$faqPreloader.fadeOut();
				}

				currentPage++;
				$categorySelect.prop( "disabled", false );
			},
			/* eslint-enable complexity */
			error: function( jqXHR, exception ) {
				if ( currentPage === 1 ) {
					$faqMessage.show( 0 );
					$faqMain.fadeIn( 400 );
					$faqPreloader.fadeOut( 400 );
				} else {
					$readMoreButtonTextElem?.text( readMoreButtonDefaultText );
				}
				$categorySelect.prop( "disabled", false );
				console.log( exception );
			},
			complete: function() {
				ajax = null;
			}
		} );
	}

	async function handleImage( image ) {
		try {
			await preloadImage( image.url, 3000 );
			$image.attr( "src", image.url );
			$image.attr( "srcset", image.srcset );
			$image.attr( "alt", image.title );
			setParentImagePosition( image.position );
		} catch ( err ) {
			console.warn( "An error occurred while loading the image:", err );
		}
	}

	function preloadImage( url, timeout = 3000 ) {
		return new Promise ( ( resolve, reject ) => {
			const img = new Image();

			const timer = setTimeout( () => {
				img.onload = null;
				img.onerror = null;
				reject( new Error( "Image load timeout" ) );
			}, timeout );

			img.onload = () => {
				clearTimeout( timer );
				resolve( img );
			};

			img.onerror = ( e ) => {
				clearTimeout( timer );
				reject( e );
			};

			img.src = url;
		} );
	}

	function setParentImagePosition( position ) {
		const imagePosition = position;
		if ( imagePosition === "bottom" ) {
			$imageParent.addClass( "section-faq__image--position-bottom" );
		} else {
			$imageParent.removeClass( "section-faq__image--position-bottom" );
		}
	}

	function toggle( $collapse, $collapseContent ) {
		if ( $collapse.hasClass( "opened" ) ) {
			$collapseContent.slideUp( 300 );
			$collapse.removeClass( "opened" );
		} else {
			$collapseContent.slideDown( 300 );
			$collapse.addClass( "opened" );
		}
	}

	$readMoreButton.on( "click", function() {
		loadMoreQuestions();
	} );

	$( document.body ).offset();

	if ( !$categorySelect.hasClass( "select2-hidden-accessible" ) ) {
		$categorySelect.select2( {
			minimumResultsForSearch: -1,
			dropdownParent: block.find( "[data-faq-select-wrap]" ),
			dropdownCssClass: "custom-dropdown"
		} );

	}

	let preventSelectClosing = false;

	$categorySelect.on( "select2:open", () => {
		preventSelectClosing = true;
		$categorySelectWrap.find( ".select2-dropdown" ).hide();

		requestAnimationFrame( () => {
			$categorySelectWrap.find( ".select2-dropdown" ).slideDown();
		} );
	} );

	$categorySelect.on( "select2:closing", ( event ) => {
		if ( preventSelectClosing ) {
			event.preventDefault();
			preventSelectClosing = false;
			$categorySelectWrap.find( ".select2-dropdown" ).slideUp( () => {
				$categorySelect.select2( "close" );
			} );
		}
	} );

	$categorySelect.on( "select2:select", () => {
		selectedCategory = $categorySelect.val();
		currentPage = 1;
		const $selectedOption = $categorySelect.find( "option[value=\"" + selectedCategory + "\"]" );
		$categorySelect.prepend( $selectedOption );
		loadMoreQuestions();
		let lang = $( "html" ).attr( "lang" );
		if ( window.doGTranslate && lang ) {
			window.doGTranslate( lang );
		}
	} );

	$faqList.on( "click", ( e ) => {
		const $collapseToggle = $( e.target ).closest( "[data-collapse-toggle]" );

		if ( !$collapseToggle.length ) {return;}

		const $collapse = $collapseToggle.closest( "[data-collapse-item]" );
		const $collapseContent = $collapse.find( "[data-collapse-content]" );

		toggle( $collapse, $collapseContent );
	} );
};

themeUtils.loadBlock( initBlock, "faq", ".section-faq" );
